import styles from '../../Article/Documents/Step1/components/UltraSwitch/UltraSwitch.module.scss';
import { MODEL } from './api';

/**
 * 首页标题下方的模型切换，外观沿用原来的 Normal / Ultra 开关（UltraSwitch），
 * 但绑定新版写作流程的生成引擎，而不是 summaryStore.useUltra。
 */
export default function EngineSwitch({ model, onChange }) {
    const isPremium = model === MODEL.ACADEMIC;
    const select = (next) => {
        if (next !== model) onChange?.(next);
    };
    const keyHandler = (next) => (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            select(next);
        }
    };

    return (
        <div className={styles.switchWrapper}>
            <div className={styles.switchContainer}>
                <div className={styles.switchTrack} role="radiogroup" aria-label="生成引擎">
                    <div
                        className={`${styles.slider} ${isPremium ? styles.ultraActive : styles.normalActive}`}
                    />
                    <div
                        role="radio"
                        aria-checked={!isPremium}
                        tabIndex={0}
                        className={`${styles.switchOption} ${!isPremium ? styles.active : ''}`}
                        onClick={() => select(MODEL.NORMAL)}
                        onKeyDown={keyHandler(MODEL.NORMAL)}
                    >
                        学术模型
                    </div>
                    <div
                        role="radio"
                        aria-checked={isPremium}
                        tabIndex={0}
                        className={`${styles.switchOption} ${isPremium ? styles.active : ''}`}
                        onClick={() => select(MODEL.ACADEMIC)}
                        onKeyDown={keyHandler(MODEL.ACADEMIC)}
                    >
                        <span className={styles.ultraLabel}>
                            超级自研学术模型
                            <span className={styles.starIcon}>✨</span>
                        </span>
                    </div>
                </div>
            </div>
        </div>
    );
}
